(function () {
  if (window.veloCartUpsellBound) return;
  window.veloCartUpsellBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-velo-upsell-add]');
    if (!btn) return;
    event.preventDefault();

    var item = btn.closest('[data-velo-upsell-item]');
    var select = item ? item.querySelector('select') : null;
    var variantId = select ? select.value : btn.getAttribute('data-variant-id');
    // Works with either cart style: slide-out drawer or add-to-cart pop-up
    var host = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!variantId || !host || btn.disabled) return;

    var wrapper = btn.closest('.velo-upsell');
    var errorEl = wrapper ? wrapper.querySelector('.velo-upsell__error') : null;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    if (errorEl) errorEl.hidden = true;

    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: host
          .getSectionsToRender()
          .map(function (s) {
            return s.id;
          })
          .join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'Could not add this item.');
        }
        host.renderContents(result.data);
      })
      .catch(function (error) {
        btn.disabled = false;
        btn.textContent = label;
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      });
  });
})();
